var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": ".98rem" } },
    [
      _c("topbar", { attrs: { text: "活动中心" } }),
      _vm._v(" "),
      !_vm.emptyStatus
        ? _c(
            "ul",
            _vm._l(_vm.activeList, function(item) {
              return _c(
                "li",
                {
                  on: {
                    click: function($event) {
                      _vm.to("activityDetail?activeId=" + item.activeId)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "titleBox" }, [
                    _c("div", { staticClass: "circular" }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item.activeTheme))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "time" }, [
                    _vm._v(_vm._s(item.activeTime))
                  ])
                ]
              )
            })
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.emptyStatus
        ? _c("div", { staticClass: "emptyBox" }, [
            _c("div", { staticClass: "emptyImg" }),
            _vm._v(" "),
            _c("div", { staticClass: "emptyName" }, [
              _vm._v("目前还没有活动哦~")
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43ecf454", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43ecf454","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/activityCenter.vue
// module id = null
// module chunks = 